export type Project = {
  id: string
  title: string
  detail: string
  location: string
  image: string
}

export const projects: Project[] = [
  {
    id: 'brass-scullery',
    title: 'Unlacquered Brass Scullery',
    detail: 'Bridge faucet, 42 knobs & appliance pulls',
    location: 'Tarrytown',
    image: 'https://cdn.magicpatterns.com/uploads/c9dDJtjnMZvEYhPN5oodMq/image.png'
  },
  {
    id: 'white-oak-bath',
    title: 'White Oak Primary Bath',
    detail: 'Backlit mirror hung, bath suite & rods installed',
    location: 'Westlake Hills',
    image: 'https://cdn.magicpatterns.com/uploads/ri9GA6HP4RH5ztWJSU82KH/image.png'
  },
  {
    id: 'vaulted-kitchen',
    title: 'Vaulted Chef’s Kitchen',
    detail: 'Aged brass pulls, soft-close conversion throughout',
    location: 'Barton Creek',
    image: 'https://cdn.magicpatterns.com/uploads/fuVwiSsYZnzcZ8geDD1YQb/image.png'
  },
  {
    id: 'inset-range-wall',
    title: 'Inset Range Wall',
    detail: 'Hinge alignment, pot filler & 60 pulls set',
    location: 'Lakeway',
    image: 'https://cdn.magicpatterns.com/uploads/dNByXcZevwih3i6qVskH39/image.png'
  }
]
